import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
/// SERVICIO DE AUTENTICACION
import { AuthService } from 'app/auth/auth.service';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EnvioService {

  idEmpresa: string;
  idUsuario: string;

  private mensajeOrigen = new BehaviorSubject('');
  mensajeActual = this.mensajeOrigen.asObservable();

  constructor(
    private http:HttpClient,
    private authService:AuthService
  ) {
  this.obtienInfo();
  }

  obtienInfo()
  {
    this.idUsuario = this.authService.getIdUsuario();
    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    this.idEmpresa = infoUsu.empresaId;
  }

  puenteDatos(mensaje: string) {
    this.mensajeOrigen.next(mensaje);
  }

  getProdCertAct(){
    this.obtienInfo();
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.productos + this.idEmpresa);
  }

  getStatusEnvio(productoId: any){
    this.obtienInfo();
    let datos: any = {productoId,	envio: 1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getStatusPart + this.idEmpresa, datos);
  }

  guardaStatusEnvio(datos){
    this.obtienInfo();
    console.log(datos);

    // let datos: any = {fechaCertificar: anio,	envio: 3};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaStatus + this.idEmpresa, datos);
  }

  DesbloquearPasoEnvio(datos){
    this.obtienInfo();
    console.log(datos);
    // let datos: any = {fechaCertificar: anio,	envio: 2};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaStatus + this.idEmpresa, datos);
  }
  sendEmail_CF(datos){
    this.obtienInfo();
    console.log(datos);
    return this.http.post(DATOS_API.url+ DATOS_API.endpoints.emailsend+this.idEmpresa,datos);
    // return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaStatus + this.idEmpresa, datos);
    /*

    console.log(this.getCompanyID());
    return this.httpClient.post(this.ip+'/api_empresa/MailSenderPreview'+this.getCompanyID(),data,
    //  { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});

      */

    }

    getStatusEnvioMedir(anio: any){
      this.obtienInfo();
      let datos: any = {productoId: anio,	envio: 1};
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.getStatusPart + this.idEmpresa, datos);
    }

    guardaStatusEnvioMedir(anio: any){
      this.obtienInfo();
      let datos: any = {productoId: anio,	envio: 3};
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.guardaStatus + this.idEmpresa, datos);
    }

    DesbloquearPasoEnvioMedir(anio: any){
      this.obtienInfo();
      let datos: any = {productoId: anio,	envio: 2};
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.guardaStatus + this.idEmpresa, datos);
    }


  getStatusEnvioPulse(anio: any){
    this.obtienInfo();
  let datos: any = {productoId: anio,	envio: 1};
  return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.getStatusPart + this.idEmpresa, datos);
     }

  guardaStatusEnvioPulse(anio: any){
    this.obtienInfo();
  let datos: any = {productoId: anio,	envio: 3};
  return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.guardaStatus + this.idEmpresa, datos);
   }

   guardaStatusActivarPulse(anio: any){
     this.obtienInfo();
    let datos: any = {productoId: anio,	envio: 3};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.guardaStatus + this.idEmpresa, datos);
     }

   desbloquearPasoEnvioPulse(anio: any){
     this.obtienInfo();
   let datos: any = {productoId: anio,	envio: 2};
   return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.guardaStatus + this.idEmpresa, datos);
    }
  sendEmailPulse(datos){
    this.obtienInfo();
    return this.http.post(DATOS_API.url+ DATOS_API.endpoints.pulse.envioCorreo+this.idEmpresa,datos);

   }

     ///////////SERVICIOS FOCUS AREA
       guardaStatusEnvioFocus(encuestaID: any){
         this.obtienInfo();
         let datos: any = {encuestaID,	envio: 3};
         return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.guardaStatus + this.idEmpresa, datos);
       }

       desbloquearPasoEnvioFocus(encuestaID: any){
         this.obtienInfo();
         let datos: any = {encuestaID,	envio: 2};
         return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.guardaStatus + this.idEmpresa, datos);
       }

       getStatusEnvioFocus(encuestaID: any){
         this.obtienInfo();
         let datos: any = {encuestaID,	envio: 1};
         return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.getStatusPart + this.idEmpresa, datos);
       }

    getEstatusEnvioCorreo(){
this.obtienInfo();
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.certificar2.envioCorreo.getEstatusEnvioCorreos + this.idEmpresa+'/'+localStorage.getItem('productoID'));
  }


    actualizaEstatusEnvioCorreo(datos){
this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.certificar2.envioCorreo.actualizaEstatusEnvioCorreos + this.idEmpresa+'/'+localStorage.getItem('productoID'),datos);
  }


 }
